import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  Paper,
  Snackbar,
  Stack,
  Typography,
} from '@mui/material';
import { AddBusiness } from '@mui/icons-material';

import { AdminRoles } from '../config/DiactiveTypes';
import { getAllHospitals } from '../services/HospitalService';
import HospitalsTable from '../components/hospitals/HospitalsTable';

const HospitalsSummary = ({ role }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const canCreate = AdminRoles.includes(role);

  useEffect(() => {
    if (location.state?.successMessage) {
      setSnackbar({ open: true, message: location.state.successMessage, severity: 'success' });
      navigate(location.pathname + location.search, { replace: true, state: null });
    }
  }, [location.pathname, location.search, location.state, navigate]);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const data = await getAllHospitals();
        setItems(data);
      } catch {
        setItems([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
        <CircularProgress size={45} />
      </Box>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
      <Snackbar
        open={snackbar.open}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={3000}
        onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
      >
        <Alert
          severity={snackbar.severity}
          sx={{ mt: 10 }}
          onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      <Paper elevation={3} sx={{ padding: 3, pt: 2 }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          spacing={2}
          sx={{ mb: 2, position: 'relative' }}
        >
          <Typography variant="h6" component="h1" sx={{ textAlign: 'center' }}>
            Hospitales
          </Typography>
          {canCreate && (
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddBusiness />}
              onClick={() => navigate('/hospital/add')}
              sx={{ position: 'absolute', right: 0 }}
            >
              Añadir hospital
            </Button>
          )}
        </Stack>
        <HospitalsTable items={items} />
      </Paper>
    </Container>
  );
};

export default HospitalsSummary;
